
export default (name,value,setState) => {
    setState((prev) => {
        return {...prev,[name]:value}
    })
}